import { API_URL } from "./config";
import axios from 'axios';

const ASSETS_URL = `${API_URL}/assets`;

export interface AssetModel {
  file?: File;
  url?: string;
  id: string;
}

declare global {
  interface Window {
    assetFileDescTrigger: {
      [key: string]: any;
    };
  }
}
interface createAssetProps {
  file?: File;
  replaceFileId?: string | null | undefined;
  url?: string;
  name?: string;
  thumbnaiData?:string;
  rulesetId?: string | null;
  langCode?: string;
}

export const createAsset = async ({file, replaceFileId, url, name, thumbnaiData, rulesetId, langCode}: createAssetProps ): Promise<any> => {
  const formData = new FormData();
  if(url === undefined && file === undefined) {
    throw new Error("Either file or url must be provided");
  }
  if(thumbnaiData){
    formData.append("thumbnaiData", thumbnaiData);
  }
  if(file) {
    formData.append("file", file);
  } else if(url) {
    formData.append("url", url);
    if (name) {
      formData.append("name", name?? "");
    }
  }
  if (rulesetId) {
    formData.append("ruleset_id", rulesetId);
  }
  if (langCode) {
    formData.append("lang_code", langCode);
  }

  
  if (replaceFileId) {
    formData.append("replaceFileId", replaceFileId);
  }
  const response = await axios.put(`${ASSETS_URL}/create`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    maxContentLength: Infinity,
    maxBodyLength: Infinity,
  }).catch(error => {
    console.error("Error creating asset:", error);
    throw error;
  })
  return response.data;
};


export const getAsset = async (assetId: string): Promise<any> => {
  const response = await axios.get(`${ASSETS_URL}/${assetId}`)
    .catch(error => {
      console.error("Error fetching asset:", error);
      throw error;
    })
  return response.data;
};
const clearAssetInterval = (assetId: string) => {
  if (window?.assetFileDescTrigger?.[assetId]) {
    clearInterval(window.assetFileDescTrigger[assetId]);
  }
}
export const getAssetIfFinished = async (assetId: string): Promise<any> => {
  return new Promise((resolve, reject) => {
    window.assetFileDescTrigger = window?.assetFileDescTrigger || {};
    clearAssetInterval(assetId);
    window.assetFileDescTrigger[assetId] = setInterval(async () => {
      const response = await getAsset(assetId);
      if (response.status === 'finished') {
        clearAssetInterval(assetId);
        let desc = response?.description ?? response?.asset?.description;
        if (desc && desc.trim()?.indexOf('Asset parsing failed (') === 0) {
          reject((desc));
        } else {
          resolve({
            "asset": response,
            "success": true,
          });
        }
      } else if (response.status === 'error') {
        clearAssetInterval(assetId);
        reject(new Error('Asset processing failed'));
      }
    }, 15000);
  });  
}

export const triggerAssetDescription = async (
  assetId: string,
  rulesetId: string,
  lang_code: string,
) => {
  const response = await axios.post(`${ASSETS_URL}/${assetId}/describe`, {}, {
      params: {
        ruleset_id: rulesetId.toString(),
        lang_code
      }
    })
    .catch(error => {
      console.error("Error describing asset:", error);
      throw error;
    })
    if (response.data.asset.status === 'in_progress') {
      return getAssetIfFinished(assetId);
    } else if (response.data.asset.status === 'finished') {
      return response.data;
    }
  
};

export function checkImageExists(url: string, callback: (exists: boolean) => void) {
  const xhr = new XMLHttpRequest();
  xhr.open('HEAD', url, true);
  xhr.onload = () => {
    const contentType = xhr?.getResponseHeader('Content-Type');
    callback(xhr.status === 200 && contentType !== undefined && contentType !== null && contentType.startsWith('image/'));
  };
  xhr.onerror = () => callback(false);
  xhr.send();
}